"use client"

import type { ReactNode } from "react"
import Link from "next/link"
import { ArrowRight } from "lucide-react"

import { Alert, Button, Input, MarkVLogo } from "@/components/compass"

export type LoginFormViewProps = {
  redirectTo: string
  formAction: (formData: FormData) => void
  pending: boolean
  banner?: ReactNode
  /** Mensagem do ?erro= da URL (link de email vencido, convite inválido). */
  erro?: string | null
  fieldError: (name: string) => string | undefined
}

export function LoginFormView({
  redirectTo,
  formAction,
  pending,
  banner = null,
  erro = null,
  fieldError,
}: LoginFormViewProps) {
  return (
    <form action={formAction} className="flex flex-col gap-5">
      <input type="hidden" name="redirectTo" value={redirectTo} />

      {/* Branding do card — visível só no mobile, onde o painel de marca
          some. No desktop quem segura a marca é o aside de gradiente. */}
      <div className="flex justify-center pb-1 lg:hidden">
        <MarkVLogo variant="gradient" withWordmark size={28} />
      </div>

      {erro ? <Alert variant="danger">{erro}</Alert> : null}
      {banner}

      <div className="flex flex-col gap-4">
        <Input
          name="email"
          type="email"
          label="Email"
          placeholder="voce@empresa.com.br"
          autoComplete="email"
          required
          disabled={pending}
          error={fieldError("email")}
        />
        <Input
          name="password"
          type="password"
          label="Senha"
          placeholder="********"
          autoComplete="current-password"
          required
          disabled={pending}
          error={fieldError("password")}
        />
      </div>

      <div className="flex justify-end">
        <Link
          href="/forgot-password"
          className="text-xs font-medium text-markv-primary-accent hover:underline"
        >
          Esqueci minha senha
        </Link>
      </div>

      <Button type="submit" size="lg" loading={pending} className="w-full">
        {pending ? "Entrando..." : "Entrar"}
        {pending ? null : <ArrowRight className="size-4" aria-hidden="true" />}
      </Button>
    </form>
  )
}
